/**
 * Type guard
 */
export function isErrorWithMessage(error: unknown): error is Error {
    return (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof (error as Record<string, unknown>).message === 'string'
    );
}

/**
 * Type guard
 */
export function getErrorMessage(error: unknown): string {
    if (isErrorWithMessage(error)) {
        return error.message;
    }

    if (typeof error === 'string') {
        return error;
    }

    return 'Unknown error';
}

/**
 * Type guard
 */
export function shouldIgnoreError(error: unknown, ignoredPatterns: string[]): boolean {
    if (!isErrorWithMessage(error)) {
        return false;
    }

    return ignoredPatterns.some((pattern) => error.message.includes(pattern));
}

/**
 * Type guard
 */
export const COMMON_IGNORED_ERRORS = {
    client: [
        'ResizeObserver loop',
        'Non-Error promise rejection',
        'fetch failed',
        'Load failed',
        'cancelled',
        'AbortError',
        'Network request failed',
        'ChunkLoadError',
        'Loading chunk'
    ],
    server: [
        'ECONNREFUSED',
        'ETIMEDOUT',
        'ENOTFOUND',
        'socket hang up',
        'Client network socket disconnected',
        'ECONNRESET'
    ],
    edge: [
        'ECONNREFUSED',
        'ETIMEDOUT',
        'ENOTFOUND',
        'socket hang up',
        'Client network socket disconnected',
        'ECONNRESET',
        'fetch failed',
        'AbortError'
    ]
};

